import { controls, currencyToNumber, grouped } from "../../controls";

const attconsol = {
  label: "Attendance Consolidated",
  starting: true,
  url: "attconsol",
  pageLabel: "Attendance Consolidated",
  pageType: "history",
  visitingBranches: true,
  filter: [

    ...controls.displayText({
      tab: "filter", label: "Employee",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employee_code", controlType: "Employee", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Month", target: "Month", star: true }),
    ...controls.magicDate({ tab: "filter", name: "month", dateType: "monthYear", displayFormat: "MMMM yyyy", isRequired: true, placeHolder: "Month" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2", }),
    // ...controls.magicDateLabel({ tab: "filter", label: "To Date", target: "to_date", star: true }),
    // ...controls.magicDate({ tab: "filter", name: "to_date", dateType: "ontype", isRequired: true, placeHolder: "END OF MONTH DATE" }),
    // ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({
      tab: "filter", label: "Employement Status",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employment_status_code", controlType: "EmploymentStatus", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({
      tab: "filter", label: "Designation",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "designation_code", controlType: "Designation", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({
      tab: "filter", label: "Department",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "department_code", controlType: "Department", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({
      tab: "filter", label: "EmploymentGrade",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employment_grade_code", controlType: "EmploymentGrade", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Attendance Consolidated",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [
          { source: 'fixed', value: 'Salary Month' }, { source: 'fixed', value: '::' }, { field: 'month' },
          { source: 'fixed', value: '\n' },
        ]
      ],
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Employee Code",
        accessor: "employee_code",
        rwidth: "*"
      },
      {
        Header: "Employee Name",
        accessor: "employee_display"
      },
      {
        Header: "Present Days",
        accessor: "PresentDays"
      },
      {
        Header: "Absent Days",
        accessor: "absent_days"
      },
      {
        Header: "Month Days",
        accessor: "month_days"
      }

    ]
  }
};

export default attconsol;